import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function EmailChart() {
	const emailChartQuery = api.analytics.emailChart.useQuery({})

	return (
		<AnalyticsChart
			title="Email"
			data={emailChartQuery.data}
			isLoading={emailChartQuery.isLoading}
		/>
	)
}
